<template>
  <div id="AccountService" class="page-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>内部用户</el-breadcrumb-item>
      <el-breadcrumb-item>部门管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page">
      <el-table
        :data="tableData"
        class="tableSty"
        :highlight-current-row="true"
        row-key="id"
        border
        ref="multipleTable"
        :tree-props="{children: 'subSysDepartmentIn'}"
      >
        <el-table-column label="CMS事业部">
          <template slot-scope="scope">
            <el-input
              size="small"
              placeholder="请输入小组名称"
              v-show="scope.row.new"
              v-model="scope.row.departName"
              clearable
            ></el-input>
            <span v-if="!scope.row.new">{{scope.row.departName}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="IPRdepartLeader" >
          <template slot-scope="scope">
            <el-select
              clearable
              placeholder="请选择负责人"
              filterable
              v-model="scope.row.departLeader"
              v-show="scope.row.new"
              size="small"
            >
              <el-option
                v-for="item in principal"
                :label="item.realname"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
            <span v-if="!scope.row.new">主管：{{scope.row.departLeader}}</span>
          </template>
        </el-table-column> -->
        <el-table-column align="right">
          <template slot="header" >
            <el-button size="small" type="text" @click="addLowerLevel(true,IPRparentId)">
              <i class="el-icon-circle-plus-outline"></i>
              新增下级
            </el-button>
            <span class="positionIcon">|</span>
            <el-button size="small" type="text" @click="theEditor(IPRparentId,IPRdepartName)">
              <i class="el-icon-edit-outline"></i>
              编辑
            </el-button>
          </template>
          <template slot-scope="scope">
            <div v-show="!scope.row.new">
              <el-button
                size="small"
                type="text"
                @click="addLowerLevel(false,scope.row.id,scope.row)"
              >
                <i class="el-icon-circle-plus-outline"></i>
                新增下级
              </el-button>
                <span class="positionIcon">|</span>
              <el-button
                size="small"
                type="text"
                @click="theEditor(scope.row.id,scope.row.departName,scope.row.leaderid)"
              >
                <i class="el-icon-edit-outline"></i>
                编辑
              </el-button>
              <span class="positionIcon">|</span>
              <el-button size="small" type="text" @click="deletOpen(scope.row.id)">
                <i class="el-icon-delete"></i>
                删除
              </el-button>
            </div>
            <div v-show="scope.row.new">
              <el-button
                size="small"
                type="text"
                @click="saveLowerLevel(scope.row.id,scope.row,'ipr')"
              >保存</el-button>
              <el-button size="small" type="text" @click="cancleBrm(scope.row.id,tableData)">取消</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- brm -->
      <el-table
        :data="BRMtableData"
        class="tableSty"
        :highlight-current-row="true"
        style="margin-top: 20px;margin-bottom: 60px;"
        :tree-props="{children: 'subSysDepartmentIn'}"
        row-key="id"
        ref="BRMmultipleTable"
      >
        <el-table-column label="BRM事业部">
          <template slot-scope="scope">
            <el-input
              placeholder="请输入小组名称"
              clearable
              type="text"
              v-show="scope.row.new"
              size="mini"
              v-model="scope.row.departName"
            ></el-input>
            <span v-show="!scope.row.new">{{scope.row.departName}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="BRMdepartLeader">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.departLeader"
              placeholder="请选择负责人"
              v-show="scope.row.new"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in principal"
                :label="item.realname"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
            <span v-show="!scope.row.new">主管：{{scope.row.departLeader}}</span>
          </template>
        </el-table-column> -->
        <el-table-column align="right">
          <template slot="header">
            <el-button type="text" @click="addLowerLevel2(true,BRMparentId)">
              <i class="el-icon-circle-plus-outline"></i>
              新增下级
            </el-button>
              <span class="positionIcon">|</span>
            <el-button type="text" size="small" @click="theEditor2(BRMparentId,BRMdepartName)">
              <i class="el-icon-edit-outline"></i>
              编辑
            </el-button>
          </template>
          <template slot-scope="scope">
            <div v-show="!scope.row.new">
              <el-button type="text" @click="addLowerLevel2(false,scope.row.id,scope.row)">
                <i class="el-icon-circle-plus-outline"></i>
                新增下级
              </el-button>
                <span class="positionIcon">|</span>
              <el-button
                type="text"
                size="small"
                @click="theEditor2(scope.row.id,scope.row.departName,scope.row.leaderid)"
              >
                <i class="el-icon-edit-outline"></i>
                编辑
              </el-button>
              <span class="positionIcon">|</span>
              <el-button type="text" size="small" @click="deletOpen(scope.row.id)">
                <i class="el-icon-delete"></i>
                删除
              </el-button>
            </div>
            <div v-show="scope.row.new">
              <el-button type="text" @click="saveLowerLevel(scope.row.id,scope.row,'brm')">保存</el-button>
              <el-button type="text" @click="cancleBrm(scope.row.id,BRMtableData)">取消</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- ipr编辑 -->
    <el-dialog title="编辑" :visible.sync="theEditorShow" width="640px" style="margin-top: 10%;">
      <el-form :model="form" :rules="rules" ref="ruleForm" :require="true">
        <el-form-item label="小组名称" :label-width="formLabelWidth" prop="name">
          <el-input
            v-model="form.name"
            autocomplete="off"
            style="width: 420px;"
            placeholder="请输入小组名称"
            size="small"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="选择主管" :label-width="formLabelWidth">
          <el-select v-model="form.region" placeholder="选择主管" size="small" style="width: 80%;" filterable >
            <el-option
              v-for="item in iprTheEditordata"
              :label="item.realname"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('ruleForm')" size="small">确 定</el-button>
        <el-button
          @click="theEditorShow = false"
          size="small"
          type="TheCustom"
          style="margin-left: 10px;"
        >取 消</el-button>
      </div>
    </el-dialog>
    <!-- ipr编辑 -->

    <!-- brm编辑 -->
    <el-dialog title="编辑" :visible.sync="theEditorShow2" width="640px" style="margin-top: 10%;">
      <el-form :model="form4" :rules="rules" ref="ruleForm4">
        <el-form-item label="小组名称" :label-width="formLabelWidth" prop="name" :require="true">
          <el-input
            v-model="form4.name"
            autocomplete="off"
            style="width: 420px;"
            placeholder="请输入小组名称"
            size="small"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="选择主管" :label-width="formLabelWidth">
          <el-select v-model="form4.region" placeholder="选择主管" size="small" style="width: 80%;" filterable >
            <el-option
              v-for="item in brmTheEditordata"
              :label="item.realname"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm2('ruleForm4')" size="small">确 定</el-button>
        <el-button
          @click="theEditorShow2 = false"
          size="small"
          type="TheCustom"
          style="margin-left: 10px;"
        >取 消</el-button>
      </div>
    </el-dialog>
    <!-- brm编辑 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      BRMtableData: [],
      iprdepartLeader: [],
      iprdepartLeader2: [],
      iprTheEditor: "",
      brmTheEditor: "",
      iprTheEditordata: [],
      brmTheEditordata: [],
      rules: {
        name: [{ required: true, message: "请输入小组名称", trigger: "blur" }]
      },
      form: {
        name: "",
        region: ""
      },
      form4: {
        name: "",
        region: ""
      },
      value: "",
      lowerLevel: false,
      lowerLevel2: false,
      theEditorShow: false,
      theEditorShow2: false,
      formLabelWidth: "120px",
      Kefuid: "",
      principal: [],
      haveEdit:true,
      IPRdepartName:'',
      IPRdepartLeader:'',
      BRMdepartLeader:'',
      BRMdepartName:''
    };
  },
  mounted() {
    this.oneStep();
  },
  methods: {
    cancleBrm(id, data) {
      //取消
      let find = false;
      for (let index in data) {
        if (data[index].id === id) {
          data.splice(index, 1);
          this.haveEdit=true
          break;
        }
        if (data[index].subSysDepartmentIn) {
          //有子节点
          this.cancleBrm(id, data[index].subSysDepartmentIn); //递归调用传入子节点

        } else {
          if (index == data.length) {
            break;
          }
        }
      }
    },
    oneStep() {
      let params = {
        id: 0
      };
      fetch({
        url: "hcm/departmentin/fuByIds",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.tableData = data[0].subSysDepartmentIn;
          this.BRMtableData = data[1].subSysDepartmentIn;
          this.IPRparentId = data[0].id;
          this.BRMparentId = data[1].id;
          this.IPRdepartName=data[0].departName
          this.BRMdepartName= data[1].departName;
          this.IPRdepartLeader=data[0].departLeader
           this.BRMdepartLeader=data[1].departLeader
        }
      });
    },
    addLowerLevel(type, id, row) {
      if(!this.haveEdit){return false}
      this.haveEdit=false
      if (!type) {
        //添加子节点
        this.forSubordinate(this.tableData, row, id, 1);
      } else if (type) {
        //添加父节点
        let obj = {
          departName: "",
          id: Symbol(),
          new: true,
          parentId: id
        };
        this.tableData.push(obj);
      }
    },
    forSubordinate(data, row, departmentId, type) {
      this.canEdit = false;
      for (let item of data) {
        if (item.id == departmentId) {
          let obj = {
            departName: "",
            id: Symbol(),
            new: true,
            parentId: departmentId
          };
          if (item.subSysDepartmentIn) {
            //有子节点
            item.subSysDepartmentIn.splice(0, 0, obj);
          } else {
            //没有子节点
            let a = [];
            a.push(obj);
            item.subSysDepartmentIn = a;
          }
          if (type === 1) {
            this.$set(this, "tableData", this.$refs.multipleTable.data);
            setTimeout(()=>{
               this.$refs.multipleTable.toggleRowExpansion(row, true); // 点击展开table
            },500)
          } else if (type === 2) {
            this.$set(this, "BRMtableData", this.$refs.BRMmultipleTable.data);
            setTimeout(()=>{
               this.$refs.BRMmultipleTable.toggleRowExpansion(row, true); // 点击展开table
            },500)

          }
          return;
        } else {
          if (item.subSysDepartmentIn) {
            this.forSubordinate(
              item.subSysDepartmentIn,
              row,
              departmentId,
              type
            );
          }
        }
      }
    },
    addLowerLevel2(type, id, row) {
       if(!this.haveEdit){return false}
      this.haveEdit=false
      if (!type) {
        //添加子节点
        this.forSubordinate(this.BRMtableData, row, id, 2);
      } else if (type) {
        //添加父节点
        let obj = {
          departName: "",
          id: Symbol(),
          new: true,
          parentId: id
        };
        this.BRMtableData.push(obj);
      }
    },
    savaDepartment(params) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/departmentin/savaDepartment",
          method: "post",
          params,
          noFormat: true,
          responseType: "text"
        })
          .then(result => {
            let res = JSON.parse(result);
            let { data } = res;
            r(res.status);
            this.haveEdit=true
          })
          .catch(() => {
            j();
          });
      });
    },
    saveLowerLevel(id, data, departType) {
      if (!data.departName) {
        this.$message.error("请输入小组名称");
        return false;
      }
      let params = {
        parentId: data.parentId,
        departName: data.departName,
        departLeader: data.departLeader,
        departType
      };
      this.savaDepartment(params).then(res => {
        if (res == "10000") {
          this.$message.success("成功");
          this.oneStep();
          this.lowerLevel = false;
          data.new = false;
        } else if (res == "10400") {
          this.$message.error("部门名称重复");
          this.oneStep();
          this.lowerLevel = false;
        }
      });
    },
    deletOpen(e) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            id: e
          };
          fetch({
            url: "hcm/departmentin/deleteDepartment",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          })
            .then(result => {
              let res = JSON.parse(result);
              let { data } = res;
              if (res.status == "10000") {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.oneStep();
                this.haveEdit=true
              }else{
                this.$message.error(res.message)
              }
            })
            .catch(err => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    theEditor(e, f, h) {
      this.form.name = f;
      if (h) {
        this.form.region = parseInt(h);
      } else {
        this.form.region = "";
      }
      this.iprTheEditor = e;
      this.theEditorShow = true;
      let params = {
        departmentId: e
      };
      this.getSavaDepartment(params).then(data => {
        this.iprTheEditordata = data;
      });
    },
    theEditor2(e, f, h) {
      this.form4.name = f;
      if (h) {
        this.form4.region = parseInt(h);
      } else {
        this.form4.region = "";
      }
      this.brmTheEditor = e;
      this.theEditorShow2 = true;
      let params = {
        departmentId: e
      };
      this.getSavaDepartment(params).then(data => {
        this.brmTheEditordata = data;
      });
    },
    getSavaDepartment(params) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/userin/getListByDepartment",
          method: "post",
          params,
          noFormat: true,
          responseType: "text"
        })
          .then(result => {
            let res = JSON.parse(result);
            let { data } = res;
            if (res.status == "10000") {
              r(data);
            }
          })
          .catch(() => {
            j();
          });
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            id: this.iprTheEditor,
            departName: this.form.name,
            departLeader: this.form.region,
            departType: "ipr"
          };
          fetch({
            url: "hcm/departmentin/savaDepartment",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          })
            .then(result => {
              let res = JSON.parse(result);
              let { data } = res;
              if (res.status == "10000") {
                this.oneStep();
                this.theEditorShow = false;
                this.form.name = "";
                this.form.region = "";
              } else if (res.status == "10400") {
                this.$message.error("部门名称重复");
                this.oneStep();
                this.theEditorShow = false;
              }
            })
            .catch(err => {});
        } else {
          return false;
        }
      });
    },
    submitForm2(formName4) {
      this.$refs[formName4].validate(valid => {
        if (valid) {
          let params = {
            id: this.brmTheEditor,
            departName: this.form4.name,
            departLeader: this.form4.region,
            departType: "brm"
          };
          fetch({
            url: "hcm/departmentin/savaDepartment",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          })
            .then(result => {
              let res = JSON.parse(result);
              let { data } = res;
              if (res.status == "10000") {
                this.oneStep();
                this.theEditorShow2 = false;
                this.form4.name = "";
                this.form4.region = "";
              } else if (res.status == "10400") {
                this.$message.error("部门名称重复");
                this.oneStep();
                this.theEditorShow2 = false;
              }
            })
            .catch(err => {});
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
#AccountService {
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }
  .tableSty {
    width: 100%;
    border-right: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
  }
  .page {
    padding: 20px;
    margin: 20px 0px 20px 0px;
    background-color: white;
  }
  .page2 {
    padding: 20px;
    margin: 20px;
    background-color: white;
  }
  .positionIcon {
    color: #d9d9d9;
    padding-left: 7px;
    padding-right: 7px;
    font-weight: 200;
    line-height: 32px;
  }
  .addDiv {
    height: 50px;
    width: calc(100% - 2px);
    background-color: #f3f7ff;
    border: 1px solid #d9d9d9;
    border-top: none;
  }
  .mandatory {
    color: red;
    margin-left: 10px;
    margin-right: 5px;
  }
  .addDivInput {
    height: 30px;
    width: 245px;
    margin-top: 5px;
  }
  .el-table__expand-icon {
    border: 1px solid #d9d9d9;
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-table__expand-icon {
    .el-icon-arrow-right {
      &:before {
        content: "+";
        color: #d9d9d9;
        font-size: 12px;
      }
    }
  }
  .el-table__expand-icon--expanded {
    transform: rotate(0);
  }
  .el-table__expand-icon {
    margin-top: 4px;
  }
  .el-table__expand-icon--expanded {
    .el-icon-arrow-right {
      &:before {
        content: "-";
        color: #d9d9d9;
        font-size: 20px;
      }
    }
  }
  .cell {
    display: flex;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }
  .el-button--primary {
    color: #fff;
    background-color: #bda571;
    border-color: #bda571;
  }
  .el-button--primary:hover {
    color: #fff;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #d9d9d9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
}
</style>
